import React from "react"
import Layout from "../components/Layout"
import { graphql, useStaticQuery } from "gatsby"
import Blogs from "../components/Blogs"
import SEO from '../components/SEO'

const Blog = () => {
  const {
    allStrapiBlogs: { nodes: blogs },
  } = useStaticQuery(query)
  console.log(blogs)
  return (
    <Layout>
      <SEO
        title="Blogs"
        description="Do read my blogs and use the 'Contact Me' Section for Feedback"
      />
      <section className="blog-page">
        <Blogs blogs={blogs} title="blog" />
      </section>
    </Layout>
  )
}

export const query = graphql`
  {
    __typename
    allStrapiBlogs {
      nodes {
        slug
        title
        description
        id
        date(formatString: "DD-MM-YYY")
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        category
        content
      }
    }
  }
`
export default Blog
